import { useNativeAuthRedirect } from "../lib/native/useNativeAuthRedirect";
import { useNativePushRegistration } from "../lib/native/useNativePushRegistration";
import { useNativePushTap } from "../lib/native/useNativePushTap";

/* Null-rendering mount points for the native hooks; they live inside IonReactRouter because the tap handler needs useHistory. */
export function NativeAuthRedirectBoundary() {
  useNativeAuthRedirect();
  return null;
}

export function NativePushTapBoundary() {
  useNativePushTap();
  return null;
}

export function NativePushRegistrationBoundary() {
  useNativePushRegistration();
  return null;
}
